import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createLandscape } from '@/viz/landscape';

export default function LandscapeVisualization({ papers, artifactColors }) {
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!containerRef.current || papers.length === 0) return undefined;

    let instance = createLandscape(containerRef.current, papers, {
      artifactColors,
      onPaperClick: (id) => navigate(`/papers/${id}`),
    });

    const handleResize = () => {
      instance.destroy();
      instance = createLandscape(containerRef.current, papers, {
        artifactColors,
        onPaperClick: (id) => navigate(`/papers/${id}`),
      });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      instance.destroy();
    };
  }, [papers, artifactColors, navigate]);

  return <div className="landscape-viz" ref={containerRef} />;
}
